import { createSlice } from '@reduxjs/toolkit';

export const promptSuggestion = createSlice({
  name: 'promptSuggestion',
  initialState: {
    promptSuggestionLoading: false,
    promptSuggestionError: null,
    promptSuggestionList: [],

    autoCompletePromptsLoading: false,
    autoCompletePromptsError: null,
    autoCompletePrompts: [],

    recentlyUsedPromptsLoading: false,
    recentlyUsedPromptsError: null,
    recentlyUsedPrompts: []
  },
  reducers: {
    setPromptSuggestionList: (state, action) => {
      state.promptSuggestionList = action.payload;
      state.promptSuggestionLoading = false;
      state.promptSuggestionError = '';
    },
    setPromptSuggestionListLoading: (state, action) => {
      state.promptSuggestionList = [];
      state.promptSuggestionLoading = action.payload;
      state.promptSuggestionError = '';
    },
    setPromptSuggestionListError: (state, action) => {
      state.promptSuggestionError = action.payload;
      state.promptSuggestionLoading = false;
    },
    setAutoCompletePrompts: (state, action) => {
      state.autoCompletePrompts = action.payload;
      state.autoCompletePromptsLoading = false;
      state.autoCompletePromptsError = '';
    },
    setAutoCompletePromptsLoading: (state, action) => {
      state.autoCompletePrompts = [];
      state.autoCompletePromptsLoading = action.payload;
      state.autoCompletePromptsError = '';
    },
    setAutoCompletePromptsError: (state, action) => {
      state.autoCompletePromptsError = action.payload;
      state.autoCompletePromptsLoading = false;
    },
    setRecentlyUsedPrompt: (state, action) => {
      state.recentlyUsedPrompts = action.payload;
    },
    updateRecentlyUsedPrompt: (state, action) => {
      const newPrompt = action.payload;
      if (state.recentlyUsedPrompts.includes(newPrompt)) return;
      state.recentlyUsedPrompts = [newPrompt, ...state.recentlyUsedPrompts].slice(0, 5);
    }
  }
});

export const {
  setPromptSuggestionList,
  setPromptSuggestionListLoading,
  setPromptSuggestionListError,
  setAutoCompletePrompts,
  setAutoCompletePromptsLoading,
  setAutoCompletePromptsError,
  setRecentlyUsedPrompt,
  updateRecentlyUsedPrompt
} = promptSuggestion.actions;

export default promptSuggestion.reducer;
